export * from './baContentTop.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baContentTop/index.ts